import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MainService } from 'src/app/services/main/main.service';
import { SimpleDialogComponent } from '../simple-dialog/simple-dialog.component';
import * as REGEX from '../../shared/regex';
import { UntypedFormBuilder } from '@angular/forms';
import moment from 'moment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { getUserProfile } from 'src/app/core/session';
@Component({
  selector: 'app-profile-dialog',
  templateUrl: './profile-dialog.component.html',
  styleUrls: ['./profile-dialog.component.scss']
})
export class ProfileDialogComponent implements OnInit  {
  @ViewChild(ImageCropperComponent, { static: false }) imageCropper: ImageCropperComponent | undefined;
  userProfileData: any;
  bankDetails: any = {
    "first_name": "",
    "last_name": "",
    "individual_address": {
      "city": "",
      "country": "",
      "line1": "",
      "line2": null,
      "postal_code": "",
      "state": ""
    },
    "bank_info": [
      {
        "id": "",
        "object": "",
        "account": "",
        "account_holder_name": "",
        "account_holder_type": "",
        "account_type": null,
        "available_payout_methods": [],
        "bank_name": "",
        "country": "",
        "currency": "",
        "default_for_currency": false,
        "fingerprint": "",
        "last4": "",
        "metadata": {},
        "routing_number": "",
        "status": ""
      }
    ],
    "dob": {
      "day": null,
      "month": null,
      "year": null
    },
    "personal_id_number_provided": false,
    "ssn_last_4_provided": false,
    "verification": {
      "additional_document": {
        "back": null,
        "details": null,
        "details_code": null,
        "front": null
      },
      "details": "",
      "details_code": "",
      "document": {
        "back": null,
        "details": null,
        "details_code": null,
        "front": null
      },
      "status": ""
    },
    "payout_schedule": {
      "delay_days": null,
      "interval": ""
    },
    "email": "",
    "individual_document_verified": 0,
    "front_document_provided": 0,
    "back_document_provided": 0,
    "individual_address_verified": 0,
    "ssn_verified": 0,
    "individual_first_name_verified": 0,
    "individual_last_name_verified": 0,
    "dob_verified": 0,
    "account_name": "",
    "account_type": "",
    "payouts_enabled": 0,
    "company_address_verified": 0,
    "company_tax_id_verified": 0,
    "company_name_verified": 0,
    "display_message": "",
    "display_message_ssn": "",
    "display_message_photo": "",
    "display_message_mobile": "",
    "display_message_address": ""
  };
  cropSelection: number = 1; 
  imageSource:any;
  alternateEmail: any;
  profileImage: any;
  bankDetails_form = this.fb.group({});
  zip_company: any = null;
  image:any;
  rectangleImage:any;
  ratio: any = 1/1;
  constructor(
    public mainService: MainService,
    public dialogRef: MatDialogRef<SimpleDialogComponent>,
    private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    public _auth: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public datepipe: DatePipe,
  ) { }

  ngOnInit() {
    this.userProfileData = getUserProfile();
    if (this._auth.getProfileData) {
      this.bankDetails = this._auth.getProfileData;
    }
    this._auth.getProfileData$.subscribe((data) => {
      this.bankDetails = this._auth.getProfileData;
    })
    if (this.data.type == 52) {
      this.alternateEmail = this.data.email;
    }
   this.image = this.data.image;
   this.updateImageDimensionForRectangle(this.data.image);
    if (this.data && this.data.type == 55) {
      this.bankDetails_form = this.fb.group({
        doctor_first_name: this.fb.control({ value: this.data.values.first_name, disabled: this.bankDetails.stripe_data.individual_first_name_verified == 1 ? true : false }),
        doctor_last_name: this.fb.control({ value: this.data.values.last_name, disabled: this.bankDetails.stripe_data.individual_last_name_verified == 1 ? true : false }),
        doctor_email: this.fb.control({ value: this.data.values.email, disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        doctor_mobile: this.fb.control({ value: this.data.values.mobile, disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        // 
        doctor_speciality: this.fb.control({ value: this.data.values.doctor_speciality, disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        ind_name: this.fb.control({ value: this.data.values.ind_id, disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        sub_ind_id: this.fb.control({ value: this.data.values.sub_ind_id, disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        ind_id: this.fb.control({ value: this.data.values.ind_id, disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        sub_ind_name: this.fb.control({ value: this.data.values.sub_ind_name, disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        // 
        date_of_birth: this.fb.control({ value: this.bankDetails.stripe_data.dob_verified == 0 ? new Date(this.data.values.date_of_birth) : this.datepipe.transform(this.data.values.date_of_birth), disabled: this.bankDetails.stripe_data.dob_verified == 1 ? true : false }),
        zip: this.fb.control({ value: this.data.values.zip, disabled: this.bankDetails.stripe_data.ssn_verified == 1 ? true : false }),
        address: this.fb.control({ value: this.data.values.address, disabled: this.bankDetails.stripe_data.individual_address_verified == 1 ? true : false }),
        State: this.fb.control({ value: this.data.values.State, disabled: true }),
        city: this.fb.control({ value: this.data.values.city, disabled: true }),
        // tin: this.fb.control([{ value: this.data.values.ssn.toString().replace(/\S{5}/, "*****"), disabled: this.bankDetails.stripe_data.ssn_verified == 1 ? true : false }]),
      })
      if (this.bankDetails.stripe_data.account_type !== 'individual') {
        this.bankDetails_form.addControl('business_name', this.fb.control({ value: this.bankDetails.stripe_data.company_name, disabled: this.bankDetails.stripe_data.company_name_verified == 1 ? true : false })),
          this.bankDetails_form.addControl('business_tax_id', this.fb.control({ value: this.bankDetails.stripe_data && this.bankDetails.stripe_data.business_tax_id && this.bankDetails.stripe_data.business_tax_id || '**********', disabled: this.bankDetails.stripe_data.company_tax_id_verified == 1 ? true : false })),
          this.bankDetails_form.addControl('address_business', this.fb.group({
            "city": this.fb.control({ value: this.bankDetails.stripe_data.company_address.city, disabled: this.bankDetails.stripe_data.company_address_verified == 1 ? true : false }),
            "postal_code": this.fb.control({ value: this.bankDetails.stripe_data.company_address.postal_code, disabled: this.bankDetails.stripe_data.company_address_verified == 1 ? true : false }),
            "line1": this.fb.control({ value: this.bankDetails.stripe_data.company_address.line1, disabled: this.bankDetails.stripe_data.company_address_verified == 1 ? true : false }),
            "state": this.fb.control({ value: this.bankDetails.stripe_data.company_address.state, disabled: this.bankDetails.stripe_data.company_address_verified == 1 ? true : false })
          }))
      }
      else {
        this.bankDetails_form.addControl('tin', this.fb.control({ value: this.data.values.ssn.toString().replace(/\S{5}/, "*****"), disabled: this.bankDetails.stripe_data.ssn_verified == 1 ? true : false }))
      }
    }
  }

  ngAfterViewInit() {
    if (this.data.type == 51) {
      setTimeout(() => {
        let image_box = document.getElementsByClassName('new_div_change')[0].getElementsByTagName('div')[0];
        image_box.style.display = 'flex'
        image_box.style.alignItems = 'center'
        image_box.style.justifyContent = 'space-around'
        let move = document.getElementsByClassName('move')[0];
        if (move) {
          move.classList.add('h-100')
        }
      }, 100);
    }
  }
  

  AddAlternateEmail() {
    let userProfileData = getUserProfile();
    var emailChk = true;
    let EMAIL_REGEXP = REGEX.Email;
    if (!EMAIL_REGEXP.test(this.alternateEmail)) {
      emailChk = false;
    } else {
      emailChk = true;
    }
    if (emailChk === false) {
      this.mainService.customPopups('Please enter a valid email.', 1);
      return false;
    }
    if (userProfileData.manager_email == this.alternateEmail) {
      this.mainService.customPopups(
        'You Cannot Add your Manager email As alternate Email.',
        1
      );
      return false;
    }
    if (userProfileData.practice_email == this.alternateEmail) {
      this.mainService.customPopups(
        'Primary email and alternate email can not be same.',
        1
      );
      return false;
    }

    this.dialogRef.close(this.alternateEmail);
  }

  acceptImage() {
    this.dialogRef.close(this.profileImage);
  }

  PhotoIdEvidence = {
    photoF: { name: '' },
    photoB: { name: '' },
  };

  uploadPhotoId(event, type) {
    if (event.target.files[0].type.includes('image')) {
      if (type == 'F') {

        this.PhotoIdEvidence['photoF'] = event.target.files[0];
        return;
      }
      else {
        this.PhotoIdEvidence['photoB'] = event.target.files[0];
      }
    }
    else {
      this.mainService.customPopups('Please upload a valid image', 1)
    }
  }

  uploadImages() {
    if (this.PhotoIdEvidence.photoF == undefined || this.PhotoIdEvidence.photoF.name == '') {
      if (this.bankDetails_form.dirty) {
        let formdata = new FormData();
        formdata.append('access_token', this.bankDetails.profile[0].access_token)
        for (let keys in this.bankDetails_form.value) {
          if (keys == 'address' || keys == 'address_business') {
            continue;
          } else if (keys == "date_of_birth") {
            formdata.append('date_of_birth', moment(this.bankDetails_form.value.date_of_birth).format("YYYY-MM-DD"))
          } else {
            formdata.append(keys, this.bankDetails_form.value[keys])
          }
        }
        if (this.bankDetails.stripe_data.account_type !== 'individual') {
          formdata.append('address', JSON.stringify(this.bankDetails_form.value.address_business))
        } else {
          formdata.append('address', this.bankDetails_form.value.address)
        }
        this.mainService.uploadApi(formdata, 'edit_profile', true).subscribe(async (data) => {
          if (data.is_error == 0) {
            return this.dialogRef.close(this.PhotoIdEvidence);
          }
        })
      } else {
        this.dialogRef.close(this.PhotoIdEvidence);
      }
    } else {
      if (this.bankDetails_form.dirty) {
        let formdata = new FormData();
        formdata.append('access_token', this.bankDetails.profile[0].access_token)
        for (let keys in this.bankDetails_form.value) {
          if (keys == 'address' || keys == 'address_business') {
            continue;
          } else if (keys == "date_of_birth") {
            formdata.append('date_of_birth', moment(this.bankDetails_form.value.date_of_birth).format("YYYY-MM-DD"))
          } else {
            formdata.append(keys, this.bankDetails_form.value[keys])
          }
        }
        if (this.bankDetails.stripe_data.account_type !== 'individual') {
          formdata.append('address', JSON.stringify(this.bankDetails_form.value.address_business))
        } else {
          formdata.append('address', this.bankDetails_form.value.address)
        }
        this.mainService.uploadApi(formdata, 'edit_profile', true).subscribe(async (data) => {
          if (data.is_error == 0) {
            return this.dialogRef.close(this.PhotoIdEvidence);
          }
        })
      }
      this.dialogRef.close(this.PhotoIdEvidence);
    }
  }
  
  updateImageDimensionForRectangle(file: File) {
    if (!file) return;

    let reader = new FileReader();
    reader.onload = (e) => {
      let fileReader = e.target as FileReader;
      if (!fileReader.result) return;

      let img = new Image();
      img.src = fileReader.result as string;
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        let desiredHeight = 1000;
        let aspectRatio = 4 / 3;
        let newWidth = desiredHeight * aspectRatio;
        let newHeight = desiredHeight;

        let canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        let ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            if (blob) {
              this.rectangleImage = new File([blob], file.name, { type: 'image/png' });
            }
          }, 'image/png');
        }
      };
    };
    reader.readAsDataURL(file);
  }

  showCropper = true;
  updateCropper() {
    if (this.data.image) {
      if (this.cropSelection === 3) {
        this.data.image = this.rectangleImage;
        this.ratio = 4 / 3;
      } else {
        this.data.image = this.image;
        this.ratio = 1 / 1
      }
      this.showCropper = false;
      setTimeout(() => this.showCropper = true, 0);
    }
  }

  imageCropped_fun(event: any) {
    const blob = event.blob;
    if (blob instanceof Blob) {      
      this.imageSource = URL.createObjectURL(blob);
    }
    switch (this.cropSelection) {
      case 1:
        this.createCircularImage(this.imageSource);
        break;
      case 2:
        this.createSquareImage(this.imageSource);
        break;
      case 3:
      default:
        this.createRectangleImage(this.imageSource);
        break;
    }
  }

  setupCanvas(imageSrc, onLoadCallback) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    if (!ctx) return;

    let img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = imageSrc;
    img.onload = () => {
      onLoadCallback(img, ctx, canvas);
    };
  }

  applyShadow(ctx, offsetX, offsetY, blur) {
    ctx.shadowColor = 'rgba(0, 0, 0, 1)';
    ctx.shadowOffsetX = offsetX;
    ctx.shadowOffsetY = offsetY;
    ctx.shadowBlur = blur;
  }

  drawRoundedRect(ctx, x, y, width, height, borderRadius) {
    ctx.beginPath();
    ctx.moveTo(x + borderRadius, y);
    ctx.lineTo(x + width - borderRadius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + borderRadius);
    ctx.lineTo(x + width, y + height - borderRadius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - borderRadius, y + height);
    ctx.lineTo(x + borderRadius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - borderRadius);
    ctx.lineTo(x, y + borderRadius);
    ctx.quadraticCurveTo(x, y, x + borderRadius, y);
    ctx.closePath();
    ctx.fill();
  }

  resetShadow(ctx) {
    ctx.shadowColor = 'rgba(0, 0, 0, 0)';
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowBlur = 0;
  }

  createCircularImage(imageSrc) {
    this.setupCanvas(imageSrc, (img, ctx, canvas) => {
      let maxHeight = 400;
      let aspectRatio = img.width / img.height;
      let newWidth, newHeight;

      if (img.height > maxHeight) {
        newHeight = maxHeight;
        newWidth = newHeight * aspectRatio;
      } else {
        newWidth = img.width;
        newHeight = img.height;
      }

      canvas.width = newWidth + 50;
      canvas.height = newWidth + 50;

      let centerX = canvas.width / 2;
      let centerY = canvas.height / 2;
      let radius = newWidth / 2;

      this.applyShadow(ctx, 10, 10, 20);

      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, false);
      ctx.fillStyle = 'white';
      ctx.fill();

      this.resetShadow(ctx);

      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, false);
      ctx.clip();

      let imgX = centerX - radius;
      let imgY = centerY - (newHeight / 2);

      ctx.drawImage(img, imgX, imgY, newWidth, newHeight);

      canvas.toBlob((blob) => {
        if (blob) {
          // Assuming you have a way to handle the result
          this.handleProfileImage(blob);
        }
      }, 'image/png');
    });
  }

  createSquareImage(imageSrc) {
    this.setupCanvas(imageSrc, (img, ctx, canvas) => {
      let maxHeight = 400;
      let borderRadius = 30;
      let aspectRatio = img.width / img.height;
      let newWidth, newHeight;

      if (img.height > maxHeight) {
        newHeight = maxHeight;
        newWidth = newHeight * aspectRatio;
      } else {
        newWidth = img.width;
        newHeight = img.height;
      }

      canvas.width = newWidth + 30;
      canvas.height = newHeight + 30;

      let x = 10;
      let y = 10;

      this.applyShadow(ctx, 10, 10, 20);

      ctx.fillStyle = 'white';
      this.drawRoundedRect(ctx, x, y, newWidth, newHeight, borderRadius);

      this.resetShadow(ctx);

      ctx.clip();

      ctx.drawImage(img, x, y, newWidth, newHeight);

      canvas.toBlob((blob) => {
        if (blob) {
          // Assuming you have a way to handle the result
          this.handleProfileImage(blob);
        }
      }, 'image/png');
    });
  }

  createRectangleImage(imageSrc) {
    this.setupCanvas(imageSrc, (img, ctx, canvas) => {
      let borderRadius = 60;
      let aspectRatio = img.width / img.height;
      let newWidth = img.width;
      let newHeight = img.height;

      if (newWidth / newHeight > aspectRatio) {
        newWidth = newHeight * aspectRatio;
      } else {
        newHeight = newWidth / aspectRatio;
      }

      canvas.width = newWidth + 150;
      canvas.height = newHeight + 150;

      let x = (canvas.width - newWidth) / 2;
      let y = (canvas.height - newHeight) / 2;

      this.applyShadow(ctx, 30, 30, 70);

      ctx.fillStyle = 'white';
      this.drawRoundedRect(ctx, x, y, newWidth, newHeight, borderRadius);

      this.resetShadow(ctx);

      ctx.clip();

      ctx.drawImage(img, x, y, newWidth, newHeight);

      canvas.toBlob((blob) => {
        if (blob) {
          // Assuming you have a way to handle the result
          this.handleProfileImage(blob);
        }
      }, 'image/png');
    });
  }

  handleProfileImage(blob) {
    this.profileImage = blob;
    this.cd.detectChanges();
  }
  
}


export interface DialogData {
  title?: string;
  desc?: string;
  action?: string;
  actionClass?: string;
  type?: any;
  paymentInfo: boolean;
  send_data?: any;
  image?: any;
  email?: any;
  disabled?: any;
  tab?: any;
  values?: any;
  success?: any;
}